import { render, staticRenderFns } from "./aVersionScreenshot.vue?vue&type=template&id=16de522e&scoped=true"
import script from "./aVersionScreenshot.vue?vue&type=script&lang=js"
export * from "./aVersionScreenshot.vue?vue&type=script&lang=js"
import style0 from "./aVersionScreenshot.vue?vue&type=style&index=0&id=16de522e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16de522e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
